import React from "react";
import "./news.css";
import whatsnew from "../../images/acejay2.jpg";

export default function New() {
  return (
    <div className="servicess">
      <div className="headingyanew">
        <div className="juuyacontaineryanew">What's new</div>
      </div>
      <div className="subservices">
        <div className="serviceswraper8">
          <div className="static">
            <img src={whatsnew} alt="" className="imageyenyewe" />
            <div className="chiniyakeimage">
              <h3>Our New Computerised Diagnosis</h3>

              <h4>
                the computer gives feedback analysis on the essential systems of
                the vehicle. It identifies the system that is issuing irregular
                performance
              </h4>
            </div>
          </div>
          <div className="dynamic">
            <div className="lefttwo">
              <h3>Trust in our company services</h3>
              <li>Mechanics</li>
              <li>Buffing</li>
              <li>Spray painting</li>
              <li>Welding and fabrications</li>
              <li>Panel beating</li>

              <li>Car electrical Services</li>
            </div>
            <div className="righttwo">
              <h3>We havehigh qualitable spareparts</h3>
              <li>Selling new and used cars</li>
              <li>We have all car spareparts</li>
              <li>Car interior decor</li>
              <li>Fitting</li>
              <li>We have secure parking</li>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
